import { Tag as AntdTag } from "antd";
import type { TagProps as AntdTagProps } from "antd/es/tag";
import React from "react";

export interface TagProps extends AntdTagProps {}

const Tag = (props: TagProps) => {
  return <AntdTag {...props} />;
};

Tag.CheckableTag = AntdTag.CheckableTag;

export default Tag;
